import { Box, Typography } from "@mui/material";

export const CabItem = ({ label }: { label: string }) => (
  <Box
    sx={{
      width: 45,
      height: 40,
      bgcolor: "info.main",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 1,
      border: 1,
      borderColor: "info.dark",
    }}
  >
    <Typography variant="caption" sx={{ color: "white", fontWeight: "bold" }}>
      {label}
    </Typography>
  </Box>
);
